import request from '@/utils/request';
class PostService{
    static list(query){
        return request({
            url:'/post/getpost',
            method:'get',
            params:query
        })
    }
    static listcomment(query){
        return request({
            url:'/post/getcommentspost',
            method:'get',
            params:query
        })
    }
    static getuserlike(query){
        return request({
            url:'/post/getlikeusers',
            method:'get',
            params:query
        })
    }
    static getdataposttoid(query){
        return request({
            url:'/post/getdataposttoid',
            method:'get',
            params:query
        })
    }
    
}

export default PostService
